import { SettingsState } from './types'

const SETTINGS_STORAGE_KEY = 'settings_data'

export const getPersistedSettings = (): Record<string, any> => {
  try {
    const stored = localStorage.getItem(SETTINGS_STORAGE_KEY)
    return stored ? JSON.parse(stored) : {}
  } catch {
    return {}
  }
}

export const persistSettings = (data: Record<string, any>) => {
  try {
    localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(data))
  } catch {
    // silent fail
  }
}

const initialState: SettingsState = {
  data: getPersistedSettings(),
  isLoading: false,
  error: undefined
}

export default initialState
